import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=297c1e1c&scoped=true&"
import script from "./ListTemplate.vue?vue&type=script&lang=ts&"
export * from "./ListTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ListTemplate.vue?vue&type=style&index=0&id=297c1e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c1e1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VChipGroup,VIcon})
